import { render, staticRenderFns } from "./nobilling.vue?vue&type=template&id=0caffcb6"
import script from "./nobilling.vue?vue&type=script&lang=js"
export * from "./nobilling.vue?vue&type=script&lang=js"
import style0 from "./nobilling.vue?vue&type=style&index=0&id=0caffcb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports